//
/* GS://PROTOCOLO
 * Arquivo: src/utils/constants.js
 * Versão: 1.0.0 – Fundação Fase 1
 * Impacto da Versão: [Novo Arquivo] Centralização de constantes e enums financeiros.
 * Data: 24/12/2025
 * Responsável: Gemini (conforme Protocolo)
 *
 * Mudanças desta versão:
 * - ADICIONADO: FINANCIAL_STATUS (Estados da transação).
 * - ADICIONADO: FINANCIAL_TYPES (Receita/Despesa).
 * - ADICIONADO: STATUS_COLORS (Mapeamento visual Tailwind).
 * - ADICIONADO: PAYMENT_METHODS (Lista unificada).
 */
//

// Tipos de Transação
export const FINANCIAL_TYPES = {
  INCOME: 'INCOME',   // Receitas (Vendas, Injeção de Capital)
  EXPENSE: 'EXPENSE', // Despesas (Contas, Compras, Salários)
};

// Status da Transação
export const FINANCIAL_STATUS = {
  PENDING: 'PENDING',   // Aguardando pagamento
  PAID: 'PAID',         // Pago / Recebido
  OVERDUE: 'OVERDUE',   // Atrasado
  HELD: 'HELD',         // Retido (Caução/Garantia) - Não conta no caixa livre
  VOID: 'VOID',         // Cancelado/Estornado
};

// Mapeamento de Status para Cores (Tailwind CSS)
export const STATUS_COLORS = {
  [FINANCIAL_STATUS.PAID]: 'text-green-500 bg-green-500/10 border-green-500/20',
  [FINANCIAL_STATUS.PENDING]: 'text-yellow-500 bg-yellow-500/10 border-yellow-500/20',
  [FINANCIAL_STATUS.OVERDUE]: 'text-red-500 bg-red-500/10 border-red-500/20',
  [FINANCIAL_STATUS.HELD]: 'text-blue-400 bg-blue-400/10 border-blue-400/20',
  [FINANCIAL_STATUS.VOID]: 'text-gray-500 bg-gray-500/10 border-gray-500/20',
};

// Métodos de Pagamento Padronizados
export const PAYMENT_METHODS = {
  CREDIT_CARD: 'Cartão de Crédito',
  DEBIT_CARD: 'Cartão de Débito',
  PIX: 'PIX',
  CASH: 'Dinheiro',
  GOLDEN_POINTS: 'GoldenPoints (Saldo)',
  BANK_TRANSFER: 'Transferência Bancária',
};

// Categorias Macro (Sugestão Inicial)
export const TRANSACTION_CATEGORIES = {
  SALES: 'Vendas',
  SERVICES: 'Serviços',
  RENTALS: 'Aluguéis',
  INVENTORY: 'Reposição de Estoque',
  OPERATIONAL: 'Custos Operacionais',
  TAXES: 'Impostos',
  INVESTMENT: 'Investimento/Reserva',
};